class UnitToggle extends HTMLElement {
  connectedCallback() {
    const defaultUnit = this.getAttribute('default-unit') || 'metric';
    this.imperialUnit = this.getAttribute('imperial-unit') || 'ft';
    this.metricUnit = this.getAttribute('metric-unit') || 'cm';
    const savedUnit = localStorage.getItem('unit-toggle-preference');
    const activeUnit = savedUnit || defaultUnit;
    this.innerHTML = `
      <div class="unit-toggle">
        <div class="option${activeUnit === 'metric' ? ' active' : ''}" data-unit="${this.metricUnit}">${this.metricUnit}</div>
        <div class="option${activeUnit === 'imperial' ? ' active' : ''}" data-unit="${this.imperialUnit}">${this.imperialUnit}</div>
      </div>
    `;

    this.querySelectorAll('.option').forEach(option => {
      option.addEventListener('click', () => this.selectUnit(option.dataset.unit));
    });
    
    const initialUnit = savedUnit === this.metricUnit || savedUnit === this.imperialUnit 
      ? savedUnit 
      : (activeUnit === 'metric' ? this.metricUnit : this.imperialUnit);
    this.selectUnit(initialUnit);
  }

  selectUnit(unit) {
    this.querySelectorAll('.option').forEach(o =>
      o.classList.toggle('active', o.dataset.unit === unit)
    );

    localStorage.setItem('unit-toggle-preference', unit);

    document.querySelectorAll('.metric, .imperial').forEach(el => {
      el.style.display = '';
    });

    if (unit === this.metricUnit) {
      document.querySelectorAll('.imperial').forEach(el => el.style.display = 'none');
      document.querySelectorAll('.metric').forEach(el => el.style.display = 'block');
    } else if (unit === this.imperialUnit) {
      document.querySelectorAll('.metric').forEach(el => el.style.display = 'none');
      document.querySelectorAll('.imperial').forEach(el => el.style.display = 'block');
    }
  }
}

customElements.define('unit-toggle', UnitToggle);
